import workIcon from '../assets/qualifications/Work.png';

export const work = {
  category: 'Work Experience',
  icon: workIcon,
  list: [
    {
      title: 'Full Stack Developer',
      institution: 'OneDrug Inc.',
      program: 'Intership',
      year: 'Aug 2023 - Present',
    },
    {
      title: 'Software Developer',
      institution: 'CubeSat NB',
      program: 'Co-op',
      year: 'May 2022 - Aug 2022',
    },
    {
      title: 'Frontend Developer',
      institution: 'University of New Brunswick',
      program: 'Work-Study',
      year: 'Jan 2022 - Apr 2022',
    },
    {
      title: 'Web Developer',
      institution: 'Ontro',
      program: 'Freelance',
      year: 'Apr 2019 - May 2021',
    },
  ],
};
